<script setup lang="ts">
import Badge from '@/components/ui/badge/Badge.vue'
import RankIcon from '@/assets/icons/rank.svg'
import RankProgress from '@/components/ui/RankProgress.vue'
import ActionsWidget from '@/components/actions/ActionsWidget.vue'
import ScoreWidget from '@/components/score/ScoreWidgetMobile.vue'
import type { Move, Statistics, StatisticType } from '@/types'
import Typography from '@/components/ui/typography/Typography.vue'

const props = defineProps<{
  statistic?: Statistics
  movesQuality?: Move[]
  currentSlide: number
  statisticType: StatisticType
}>()
const emit = defineEmits(['update-statistic-type'])

const username = 'Max Moneymaker'
const rank = 4
const progress = {
  start: 1000,
  current: 1300,
  previous: 1250,
  next: 1500
}
const progressPercent =
  ((progress.current - progress.start) / (progress.next - progress.start)) * 100
const progressDelta = progress.current - progress.previous
</script>

<template>
  <div
    class="flex flex-col items-center w-full h-full overflow-y-auto text-white px-4 bg-background"
  >
    <ActionsWidget
      :moves="movesQuality || []"
      @update-statistic-type="(type) => emit('update-statistic-type', type)"
      :current-slide="props.currentSlide"
      :statisticType="props.statisticType"
    />
    <ScoreWidget v-if="statistic" :statistic="statistic" />
  </div>
</template>
